
/**
 * 지점 및 회사 정보 조회 쿼리
 */
export const GET_BRANCH_COMPANIES = `
  query getBranchCompanies {
    getBranchCompanies {
      id
      name
      companies {
        id
        name
      }
    }
  }
`;

/**
 * 센서정보 조회 쿼리
 */
export const GET_SENSOR_DATA = `
    query getSensorData($filter: String!) {
        getSensorData(filter: $filter) {
            seq
            site
            compCd
            deviceId
            deviceName
            attachedEquipmentId
            companyName
            equipmentName
            createUser
            createDate
            updateUser
            updateDate
        }
    }
`;

/**
 * 센서정보 수정 뮤테이션
 */
export const SAVE_SENSOR_DEVICE_SETTINGS = `
  mutation saveSensorDeviceSettings($req: SensorDeviceRequest!) {
    saveSensorDeviceSettings(req: $req) {
      success
      message
    }
  }
`;
/**
 * 설비 데이터 조회
 */
export const GET_EQUIPMENT_DATA = `
    query getEquipmentData($site: String!) {
        getEquipmentData(site: $site) {
            equipmentId
            equipmentName
        }
    }
`;